import React, { useEffect, useState, useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import countryList from 'react-select-country-list';
import { VrrDropdown, VrrInput } from '../../../shared_components';
import { VERTICALS } from './services';
import { getBrandErrors } from '../../../../redux/app/appActions';
import { TBrandForm } from './types';
import { TBrand } from '../types';
import { IListState } from '../../../shared_components/vrr_dropdown/types';

const BrandForm: React.FC<TBrandForm> = ({ brand, onChangeAction }) => {
  const { t } = useTranslation();
  const [currentBrand, setCurrentBrand] = useState<TBrand | undefined>(
    undefined
  );
  const error = useSelector(getBrandErrors);
  const countries = useMemo(() => countryList().getData(), []);

  useEffect(() => {
    if (brand) {
      setCurrentBrand(brand);
    }
  }, [brand]);

  const onChange = (key: keyof TBrand, value: string) => {
    const newBrand: TBrand = {
      ...currentBrand,
      [key]: value
    };
    setCurrentBrand(newBrand);
    if (onChangeAction && currentBrand) onChangeAction(newBrand);
  };

  return (
    <>
      <div className="preview-title">
        <span>{t('menu.brand.title.name')}</span>
        <hr />
      </div>
      <div className="brand-preview">
        <VrrInput
          value={currentBrand?.name ?? ''}
          onChangeAction={(e) =>
            onChange('name' as keyof TBrand, e.currentTarget.value)
          }
        />
      </div>
      <div className="preview-title">
        <span>{t('menu.brand.title.principal_website')}</span>
        <hr />
      </div>
      <div className="brand-preview">
        <VrrInput
          value={currentBrand?.principal_website ?? ''}
          onChangeAction={(e) =>
            onChange('principal_website' as keyof TBrand, e.currentTarget.value)
          }
          {...(!!error && {
            errorMessage: t(`menu.brand.${error}`)
          })}
        />
      </div>
      <div className="preview-title">
        <span>{t('menu.brand.title.country')}</span>
        <hr />
      </div>
      <div className="brand-preview">
        <VrrDropdown
          list={countries as IListState[]}
          currentValue={currentBrand?.country}
          handleChangeAction={(e: IListState) => {
            onChange('country' as keyof TBrand, e.value);
          }}
        />
      </div>
      <div className="preview-title">
        <span>{t('menu.brand.title.vertical')}</span>
        <hr />
      </div>
      <div className="brand-preview">
        <VrrDropdown
          list={VERTICALS}
          currentValue={currentBrand?.vertical}
          handleChangeAction={(e: IListState) => {
            onChange('vertical' as keyof TBrand, e.value);
          }}
        />
      </div>
    </>
  );
};

export default BrandForm;
